const documentTypes = [
  {
    country: "BR",
    code: "BR_DRIVER_LICENSE",
    translationKey: "DOCUMENT_BR_DRIVER_LICENSE",
    regex: "^[A-Z]{3}\\d{4,5}$",
  },
  {
    country: "BR",
    code: "BR_NATIONAL_ID",
    translationKey: "DOCUMENT_BR_NATIONAL_ID",
    regex: "^\\d{3}\\.\\d{3}\\.\\d{3}-\\d{2}$",
    weight: 1,
  },
  {
    country: "BR",
    code: "BR_RESIDENCE_PERMIT",
    translationKey: "DOCUMENT_BR_RESIDENCE_PERMIT",
  },
  {
    country: "CO",
    code: "CO_NATIONAL_ID",
    translationKey: "DOCUMENT_CO_NATIONAL_ID",
    regex: "^\\d{6,10}$",
    weight: 1,
  },
  {
    country: "CO",
    code: "CO_TEMPORARY_PROTECTION_PERMIT",
    translationKey: "DOCUMENT_CO_TEMPORARY_PROTECTION_PERMIT",
    regex: "^\\d{6,10}$",
  },
  {
    country: "CU",
    code: "CU_NATIONAL_ID",
    translationKey: "DOCUMENT_CU_NATIONAL_ID",
    regex: "^\\d{11}$",
    weight: 1,
  },
  {
    country: "EC",
    code: "EC_CEDULA",
    translationKey: "DOCUMENT_ECUADOR",
    regex: "^\\d{10}$",
  },
  {
    country: "ID",
    code: "ID_KTP",
    translationKey: "DOCUMENT_ID_KTP",
    regex: "^\\d{16}$",
    weight: 1,
  },
  {
    country: "MX",
    code: "MX_NATIONAL_ID",
    translationKey: "DOCUMENT_MEXICO",
    regex: "^[A-Z]{4}\\d{6}[HM][A-Z]{5}[A-Z0-9]\\d$",
    weight: 1,
  },
  {
    country: "PA",
    code: "PA_CEDULA",
    translationKey: "DOCUMENT_PA_CEDULA",
    regex: "^[A-Z]?-?\\d{1,2}-\\d{3,4}-\\d{3,5}$",
  },
  {
    country: "PA",
    code: "PA_PROVISIONAL_RESIDENCE_PERMIT",
    translationKey: "DOCUMENT_PA_PROVISIONAL_RESIDENCE_PERMIT",
    regex: "^[A-Z0-9]{8,12}$",
  },
  {
    country: "PE",
    code: "PE_DNI",
    translationKey: "DOCUMENT_PE_DNI",
    regex: "^\\d{9}$",
    weight: 1,
  },
  {
    country: "PE",
    code: "PE_FOREIGNER_CARNET",
    translationKey: "DOCUMENT_PE_FOREIGNER_CARNET",
    regex: "^\\d{9}$",
  },
  {
    country: "PH",
    code: "PH_DRIVER_LICENSE",
    translationKey: "DOCUMENT_PH_DRIVER_LICENSE",
    regex: "^[A-Z]\\d{2}-\\d{2}-\\d{6}$",
  },
  {
    country: "PH",
    code: "PH_NATIONAL_ID",
    translationKey: "DOCUMENT_PH_NATIONAL_ID",
    regex: "^\\d{4}-\\d{4}-\\d{4}-\\d{4}$",
    weight: 1,
  },
  {
    country: "PH",
    code: "PH_POSTAL_ID",
    translationKey: "DOCUMENT_PH_POSTAL_ID",
    regex: "^\\d{4}-\\d{4}-\\d{4}-\\d{4}$",
  },
  {
    country: "PH",
    code: "PH_UMID",
    translationKey: "DOCUMENT_PH_UMID",
    regex: "^\\d{4}-\\d{4}-\\d{4}-\\d{4}$",
  },
  {
    country: "PH",
    code: "PH_TAXPAYER_ID",
    translationKey: "DOCUMENT_PH_TAXPAYER_ID",
    regex: "^\\d{3}-\\d{3}-\\d{3}-\\d{3}$",
  },
  {
    country: "PH",
    code: "PH_PHILHEALTH_ID",
    translationKey: "DOCUMENT_PH_PHILHEALTH_ID",
    regex: "^\\d{2}-\\d{9}-\\d{1}$",
  },
  {
    country: "VE",
    code: "VE_NATIONAL_ID",
    translationKey: "DOCUMENT_VE_NATIONAL_ID",
    regex: "^[VE]-?\\d{7,8}$",
    weight: 1,
  },
  {
    country: "ZA",
    code: "ZA_GREENBOOK",
    translationKey: "DOCUMENT_ZA_GREEN_BOOK",
    regex: "^\\d{13}$",
  },
  {
    country: "ZA",
    code: "ZA_NATIONAL_ID",
    translationKey: "DOCUMENT_ZA_NATIONAL_ID",
    regex: "^\\d{13}$",
    weight: 1,
  },
  {
    country: "",
    code: "OTHER",
    translationKey: "DOCUMENT_OTHER",
    regex: "^.+$",
  },
];

export default documentTypes;
